module.exports = __webpack_public_path__ + "img/Perks-Gift-35.5e5af926.png";